<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="内容">
                  <el-input  v-model="queryForm.content"></el-input>
              </el-form-item>
              <el-form-item label="权重">
                  <el-input  v-model="queryForm.weight"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getModelIncomeSubItemListList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addModelIncomeSubItemList"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editModelIncomeSubItemList(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteModelIncomeSubItemList(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshModelIncomeSubItemListList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="modelIncomeSubItemListList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            v-if="type == 11"
            prop="content"
            label="内容"
            min-width="180"
        > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        v-else
        prop="modelName"
        label="内容"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="weight"
        label="权重"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkModelIncomeSubItemList(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editModelIncomeSubItemList(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteModelIncomeSubItemList(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="modelIncomeSubItemListStates[modelIncomeSubItemListState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="modelIncomeSubItemList"
          ref="modelIncomeSubItemListForm"
          :rules="rules"
          label-width="120px"
          size="small"
        >
            <el-form-item
                label="内容"
                prop="content"
            >
                <GridSelect
                    title='选择用户'
                    labelName='userName'
                    labelValue='id'
                    :disabled="modelIncomeSubItemListState == 'check'"
                    v-if="type == 8"
                    :value='modelIncomeSubItemList.content'
                    :limit='1'
                    style='width: 176px'
                    size='small'
                    placeholder='请选择用户'
                    @getValue='getValue'
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl='/mpp/user/findList'
                    entityBeanName='mppUser'
                    queryEntityUrl='/mpp/user/get'
                >
                </GridSelect>
                <el-select
                    style="width: 176px;"
                    clearable
                    v-model='modelIncomeSubItemList.content'
                    :disabled="modelIncomeSubItemListState == 'check'"
                    size='small'
                    v-else-if="type == 9"
                    placeholder='请选择等级'
                >
                    <el-option v-for='(item,index) in mppGradeList' :label='item.gradeName' :value='item.id'></el-option>
                </el-select>
                <el-select
                    style="width: 176px;"
                    clearable
                    v-model='modelIncomeSubItemList.content'
                    :disabled="modelIncomeSubItemListState == 'check'"
                    size='small'
                    v-else-if="type == 10"
                    placeholder='请选择代理等级'
                >
                    <el-option v-for='(item,index) in agentLevelEnumList' :label='item.agentName' :value='item.id'></el-option>
                </el-select>
                <el-input
                    size='small'
                    v-else
                    style="width: 176px;"
                    :disabled="modelIncomeSubItemListState == 'check'"
                    v-model='modelIncomeSubItemList.content'
                ></el-input>
            </el-form-item>
          <el-form-item
            label="权重"
            prop="weight"
          >
            <el-input
                style='width: 176px'
              size="small"
              v-model="modelIncomeSubItemList.weight"
              :disabled="modelIncomeSubItemListState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="modelIncomeSubItemListState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelIncomeSubItemListList();
                    this.getModelIncomeSubItemListList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelIncomeSubItemListList();
                    this.getModelIncomeSubItemListList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     itemId: '', //子项ID
                     content: '', //内容
                     weight: '', //权重
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelIncomeSubItemListState: 'add',
                modelIncomeSubItemListStates: {
                    add: '新建子项',
                    check: '查看子项',
                    edit: '修改子项'
                },

                multipleSelection: [],
                modelIncomeSubItemListList: [],
                modelIncomeSubItemList: {
                    id: '', //
                    itemId: '', //子项ID
                    content: '', //内容
                    weight: '', //权重
                },
                btnLoading: false,

                rules: {
                    itemId: [{ required: true, message: '子项ID不能为空', trigger: 'blur' }],
                    content: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
                    weight: [{ required: true, message: '权重不能为空', trigger: 'blur' }],
                },
                type: '',
                mppGradeList: [],
                agentLevelEnumList: []
            };
        },
        created() {
            this.getMppGradeList();
            this.getAgentLevelEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValue(value) {
                this.modelIncomeSubItemList.content = value;
            },
            // 获取用户等级
            getMppGradeList() {
                get(`/mpp/grade/findList`, { pageNum: 1, pageSize: 100 }).then((res) => {
                    if (res.success && res.code == 200) {
                        this.mppGradeList = res.page.list;
                    }
                });
            },

            // 获取代理等级
            getAgentLevelEnum() {
                get('/mpp/app/agentlevel/findAll').then((res) => {
                    if (res.success) {
                        this.agentLevelEnumList = res.list;
                    }
                });
            },
            init(val, type){
                this.queryForm.itemId = val;
                this.modelIncomeSubItemList.itemId = val;
                this.type = type;
                this.resetModelIncomeSubItemListList();
                this.getModelIncomeSubItemListList();
            },
            resetModelIncomeSubItemListList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelIncomeSubItemListList = [];
            },
            resetDialog() {
                this.modelIncomeSubItemListState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      itemId: this.queryForm.itemId, //子项ID
                      content: '', //内容
                      weight: '', //权重
                };
                this.getModelIncomeSubItemListList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelIncomeSubItemList = {
                      id: '', //
                      itemId: this.modelIncomeSubItemList.itemId, //子项ID
                      content: '', //内容
                      weight: '', //权重
                };
            },
            submitForm() {
                if (this.modelIncomeSubItemListState == 'add') {
                    this.$refs.modelIncomeSubItemListForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/incomesubitemlist/add`,{ ...this.modelIncomeSubItemList }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelIncomeSubItemListList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelIncomeSubItemListState == 'edit') {
                    this.$refs.modelIncomeSubItemListForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/incomesubitemlist/edit`,{ ...this.modelIncomeSubItemList }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelIncomeSubItemListList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelIncomeSubItemList() {
                this.showDialog = true;
                this.modelIncomeSubItemListState = 'add';
            },
            checkModelIncomeSubItemList(modelIncomeSubItemListId) {
                console.log(modelIncomeSubItemListId);
                this.currentModelIncomeSubItemListId = modelIncomeSubItemListId;

                this.getModelIncomeSubItemListById();
                this.showDialog = true;
                this.modelIncomeSubItemListState = 'check';
            },
            editModelIncomeSubItemList(modelIncomeSubItemListId) {
                console.log('modelIncomeSubItemList', modelIncomeSubItemListId);
                if (modelIncomeSubItemListId) {
                    this.currentModelIncomeSubItemListId = modelIncomeSubItemListId;
                    this.getModelIncomeSubItemListById();
                } else {
                    this.modelIncomeSubItemList = { ...this.modelIncomeSubItemList, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelIncomeSubItemListState = 'edit';
            },
            deleteModelIncomeSubItemList(modelIncomeSubItemListId) {
                let ids = '';
                if (modelIncomeSubItemListId) {
                    ids = modelIncomeSubItemListId;
                } else {
                    ids = this.multipleSelection.map((modelIncomeSubItemList) => modelIncomeSubItemList.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/incomesubitemlist/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelIncomeSubItemListList();
                                this.getModelIncomeSubItemListList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelIncomeSubItemListList() {
                this.resetModelIncomeSubItemListList();
                this.getModelIncomeSubItemListList();
            },
            getModelIncomeSubItemListList(query = {}) {
                this.loading = true;
                get(`/model/incomesubitemlist/findListPop`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize, modelType: this.type }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelIncomeSubItemListList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelIncomeSubItemListById() {
                get(`/model/incomesubitemlist/get`,{ id: this.currentModelIncomeSubItemListId }).then((res) =>{
                    if(res.success){
                      this.modelIncomeSubItemList = { ...this.modelIncomeSubItemList, ...res.modelIncomeSubItemList };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelIncomeSubItemListList() {
                //this.btnLoading = true;
                exprotExcel(`/model/incomesubitemlist/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/incomesubitemlist/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/incomesubitemlist/importData`,formData);
              this.refreshModelIncomeSubItemListList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelIncomeSubItemListList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelIncomeSubItemListList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>